import {
  POSTING_PERSISTENT_STATE,
  PROPERTY_TYPE,
  PROPERTY_LOCATION,
  PROPERTY_CONTACT_INFORMATION,
  PROPERTY_ACCOUNT,
  PROPERTY_NAME,
  PROPERTY_DESCRIPTION,
  PROPERTY_FLOORPLANS,
  PROPERTY_AMENITIES,
  PROPERTY_IMAGES,
  PAYMENT_INFO,
} from '../types';


const initialState = {
    type: 0,
    location: {
        address: '',
        city: '',
        state: 0,
        zip: '',
        coordinates: {},
        availableLocations: {},
    },
    contact: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
    },
    account: {
        email: '',
        password: '',
        password_confirmation: '',
    },
    name: '',
    description: '',
    floorplans: [{bedrooms: 0, bathrooms: 0, sq: '', rent: ''}],
    amenities: [],
    images: [],
    payment: {
        address: '',
        zip: '',
        cardNumber: '',
        securityCode: '',
        expirationMonth: 0,
        expirationYear: 0,
    },
    restored: 0,
};

const postingReducer = (state = initialState, action) => {
    switch (action.type) {
        case POSTING_PERSISTENT_STATE:
            let payload = Object.assign(
                {},
                initialState,
                ...Object.keys(initialState).map(k => k in action.payload && { [k]: action.payload[k] })
            );
            return payload;
        case PROPERTY_TYPE:
            return {
                ...state,
                type: action.payload,
            };
        case PROPERTY_LOCATION:
            return {
                ...state,
                location: action.payload,
            };
        case PROPERTY_CONTACT_INFORMATION:
            return {
                ...state,
                contact: action.payload,
            };
        case PROPERTY_ACCOUNT:
            return {
                ...state,
                account: action.payload,
            };
        case PROPERTY_NAME:
            return {
                ...state,
                name: action.payload,
            };
        case PROPERTY_DESCRIPTION:
            return {
                ...state,
                description: action.payload,
            };
        case PROPERTY_FLOORPLANS:
            return {
                ...state,
                floorplans: action.payload,
            };
        case PROPERTY_AMENITIES:
            return {
                ...state,
                amenities: action.payload,
            };
        case PROPERTY_IMAGES:
            return {
                ...state,
                images: action.payload,
            };
        case PAYMENT_INFO:
            return {
                ...state,
                payment: action.payload,
            };
        default:
            return state;
    }
};

export default postingReducer;
